import { render, staticRenderFns } from "./FormsGalleryList.vue?vue&type=template&id=65a6b7e2&scoped=true"
import script from "./FormsGalleryList.vue?vue&type=script&lang=js"
export * from "./FormsGalleryList.vue?vue&type=script&lang=js"
import style0 from "./FormsGalleryList.vue?vue&type=style&index=0&id=65a6b7e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a6b7e2",
  null
  
)

export default component.exports